export default __webpack_public_path__ + "static/hero-b011bd22689b9b95cda198f17237d72e.jpg";